import React, {useRef, useState} from "react";
import {
  AiFillInstagram,
  AiFillTwitterCircle,
  AiOutlineWhatsApp,
  AiFillYoutube,
} from "react-icons/ai";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import {toast} from 'react-toastify';
import Loader from "./Loader";


const Footer = () => {
 
    //setting up recaptcha token
    const recaptchaRef = useRef(null);
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [err, setErr] = useState('')
    const onRecaptchaChange = (token) => {
      setRecaptchaToken(token);
      setErr('')
      console.log(token)
    };
  

  const form = useRef()
  console.log(form);


  const [loading, setLoading] = useState(false);


  const service_id = process.env.REACT_APP_SERVICE_ID;
  const template_id = process.env.REACT_APP_TEMPLATE_ID;
  const public_key = process.env.REACT_APP_PUBLIC_KEY;

  

  const handleSubmit = (e) => {
    e.preventDefault();

    if (recaptchaToken) {
      if (
        form.current[0].value === "" ||
        form.current[1].value === "" ||
        form.current[2].value === ""
      ) {
        toast.error("Please Fill all required fields to submit! 😢");
    
  
      } else {
        emailjs.sendForm(service_id, template_id, form.current, public_key).then(
          (result) => {
            recaptchaRef.current.reset();
            setLoading(false);
            toast.success("Message sent successfully!🎉🎉🎉");
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          toast.error(error.text);
          }
        );
  
        setLoading(true);
        form.current.reset();
       
      
      }
    }else{
      toast.error("Please complete the reCaptcha")
    }   
  }


  return (
    <section className="bg-black pt-6 pb-12 md:py-20 px-8 md:px-16 flex  items-center gap-10 -mt-[1px]
    lg:flex-row flex-col
    ">
      

      <div className="flex justify-between items-center text-white self-start lg:w-[55%] w-full lg:flex-row flex-col-reverse">
        <div className="socials flex  md:flex-col gap-4  self-start text-primary mr-5 pt-4 md:pt-0">
        <Link
          to="http://instagram.com/temmiedesigns"
          className="text-white hover:bg-primary p-2 rounded-full transition ease-in  "
        >
          <AiFillInstagram size="1.5rem" />
        </Link>

        <Link
          to="http://twitter.com/temmiedesigns"
          className="text-white hover:bg-primary p-2 rounded-full transition ease-in "
        >
          <AiFillTwitterCircle size="1.5rem" />
        </Link>

        <Link
          to="https://wa.me/message/XZB4MENVSUYXG1"
          className="text-white hover:bg-primary p-2 rounded-full transition ease-in "
        >
          <AiOutlineWhatsApp size="1.5rem" />
        </Link>
        <Link
          to="https://youtube.com/@learnwithtemmie2022"
          className="text-white hover:bg-primary p-2 rounded-full transition ease-in "
        >
          <AiFillYoutube size="1.5rem" />
        </Link>
      </div>
      
        <div className="self-start">
          <h1 className="md:text-[64px] text-[32px]  md:leading-[64px] leading-[32px] mb-4 font-medium capitalize">
            GOT SOMETHING <br/>FOR ME?
          </h1>
          <p className="mb-4 text-[20px]">
            Connect with me through my socials or send an e-mail across directly
            or through this form.
          </p>
          <p className="font-bold">
            <a href="mailto:tmdarowolo@gmail.com">tmdarowolo@gmail.com</a>
          </p>
        </div>

      </div>

      <div className="contact-form w-full mx-auto self-start lg:flex-1 lg:self-end">
        <form ref={form} action="" className="w-full" onSubmit={handleSubmit}>
          <div className="flex flex-col bg-[#ffffff40] px-3 py-1 text-white text-sm mb-2">
            <label className="" htmlFor="name" >
              Name:
            </label>
            <input
              type="text"
              className="bg-transparent focus:ring-0 outline-none w-full"
              name="name"
            />
          </div>

          <div className="flex flex-col bg-[#ffffff40] px-3 py-1 text-white text-sm mb-2">
            <label className="" htmlFor="email">
              Email:
            </label>
            <input
              type="email"
              className="bg-transparent focus:ring-0 outline-none"
              name="email"
            />
          </div>


          <div className="flex flex-col bg-[#ffffff40] px-3 py-1 text-white text-sm mb-2">
            <label className="" htmlFor="message">
              Message:
            </label>
            <textarea
              row="50"
              col="10"
              className="bg-transparent focus:ring-0 outline-none"
              name="message"
            ></textarea>
          </div>
          <ReCAPTCHA 
            onChange={onRecaptchaChange}
            sitekey={process.env.REACT_APP_SITE_KEY}
            ref={recaptchaRef}/>
              <p className="text-left text-red-600 mt-4">{err}</p>

          <div className="w-full flex justify-start">
         
            <button className="border text-black flex items-center hover:bg-slate-200 px-10 py-3 space-x-2 border-white bg-white" type="submit">
           {loading ? <Loader/> : 'Submit Form'}
            </button>

           
          </div>

          {/* <div>
            {loading &&  <Loader/>}
            </div> */}

{/* 
            {success ? (
              <p className="text-white text-center mt-4 font-medium">
                Your Meessage has been sent successfully 😎
              </p>
            ):(<p className="text-white text-center mt-4 font-bold">{error}</p>) } */}

        {/* <p className="text-red-500 text-left mt-4 font-medium">{validation}</p> */}
        </form>
      </div>
    </section>
  );
};

export default Footer;
